module.exports = __webpack_public_path__ + "static/img/serve7Model.5999989c.png";